<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Smileys.16"
    xmlns="http://www.w3.org/2000/svg"
    width="70"
    height="70"
    viewBox="0 0 70 70"
  >
    <path id="Path_8614" data-name="Path 8614" d="M0,0H70V70H0Z" fill="none" />
    <path
      id="Path_8615"
      data-name="Path 8615"
      d="M55.5,29.25a26.25,26.25,0,0,0-52.5,0M29.25,55.5A26.28,26.28,0,0,0,55.5,29.25M3,29.25A26.278,26.278,0,0,0,29.25,55.5"
      transform="translate(5.75 5.75)"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8616"
      data-name="Path 8616"
      d="M28.626,9.558a.729.729,0,1,0,.732.729.725.725,0,0,0-.732-.729M9.116,9.5a.729.729,0,1,0,.732.729A.725.725,0,0,0,9.116,9.5M8.711,28.458a15.53,15.53,0,0,1,20.417,0"
      transform="translate(16.081 18.208)"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>
